<template>
    <div class="z-0 inline-block align-middle">
        <div class="flex">
            <span class="my-auto ml-2 text-sm font-medium text-gray-700 capitalize">{{ data.label }}</span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
    selected: {
        type: Boolean,
        required: true,
    },
});
</script>
